import { Styles } from 'shared/types';

export const NoData: Styles = {
  height: 500,
};
